module.exports = function (options)
{

    return {
        ...options,

        // Overwrite options
        // language: 'en',

        // Add styles
        stylesSet: [
            { name: 'Normaal', element: 'p', attributes: {'class': ''} },
            { name: 'Primaire knop', element: 'a', attributes: {'class': 'btn-primary'} },
            { name: 'Secundaire knop', element: 'a', attributes: {'class': 'btn-secondary'} },
            { name: 'Tertiaire knop', element: 'a', attributes: {'class': 'btn-tertiary'} },

            { name: 'Tekst extra klein', element: 'p', attributes: {'class': 'text-xs'} },
            { name: 'Tekst klein', element: 'p', attributes: {'class': 'text-sm'} },
            { name: 'Tekst normaal', element: 'p', attributes: {'class': 'text-base'} },
            { name: 'Tekst groot', element: 'p', attributes: {'class': 'text-lg'} },
            { name: 'Tekst extra groot', element: 'p', attributes: {'class': 'text-xl'} },
            { name: 'Tekst 2XL', element: 'p', attributes: {'class': 'text-2xl'} },
            { name: 'Tekst 3XL', element: 'p', attributes: {'class': 'text-3xl'} },
            { name: 'Tekst 4XL', element: 'p', attributes: {'class': 'text-4xl'} },
        ],

        // Allow tags.
        format_tags: 'p;h1;h2;h3;h4;h5',

    };

};
